var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLayout',{attrs:{"title":_vm.title,"half":_vm.half},scopedSlots:_vm._u([{key:"notes",fn:function(){return [(_vm.endYear >= _vm.provisionalYear)?_c('p',[_vm._v(" The datapoints for 2022 and 2023 are considered provisional due to the time lag in filing applications in the PATSTAT database. ")]):_vm._e()]},proxy:true}])},[_c('DataGetter',{staticClass:"patent-treemap",attrs:{"url":_vm.apiRoute,"params":{
      countryISO: _vm.countryISO,
      topic: 'Patents',
      indicator: 'Detail',
      startYear: _vm.startYear,
      endYear: _vm.endYear,
    },"lazy":""},on:{"fetched":_vm.setTotal},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('p',{staticClass:"f-ui-2"},[_vm._v(" Total: "),_c('strong',[_vm._v(_vm._s(_vm.formatNumber(_vm.total)))]),_vm._v(" energy-related patents between "+_vm._s(_vm.startYear)+" and "+_vm._s(_vm.endYear)+". ")]),_c('DataSlicer',{attrs:{"data":data,"x-axis-dimension":"country","y-axis-dimension":_vm.groupBy,"value-dimension":"value"},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData }){return [_c('Chart',{attrs:{"options":{
          ..._vm.chartOptions,
          series: [
            {
              data: [
                { name: 'Clean Energy', id: 'Clean Energy' },
                { name: 'Fossil fuel', id: 'Fossil Fuel' },
                ..._vm.formatSeries(slicedData, data),
              ],
            },
          ],
        }}}),(_vm.showLegend)?_c('ChartLegend',{attrs:{"legend-items":_vm.formatSeries(slicedData),"hover-series":() => {}}}):_vm._e()]}}],null,true)})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }